import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ISearchableService} from './ISearchableService';

@Injectable({
    providedIn: 'root'
})
export class SearchService implements OnInit, OnDestroy
{
    private searchResult: any;
    private searchableService: ISearchableService;

    private _direction: string = 'DESC';

    get direction(): string
    {
        return this._direction;
    }

    set direction(value: string)
    {
        this._direction = value;
    }

    private _field: string = 'id';

    get field(): string
    {
        return this._field;
    }

    set field(value: string)
    {
        this._field = value;
    }

    private _pageSize = 10;

    get pageSize(): number
    {
        return this._pageSize;
    }

    set pageSize(value: number)
    {
        this._pageSize = value;
    }

    private _searchableCriteria: any;

    get searchableCriteria(): any
    {
        return this._searchableCriteria;
    }

    set searchableCriteria(value: any)
    {
        this._searchableCriteria = value;
    }

    private _currentPage = 0;

    get currentPage(): number
    {
        return this._currentPage;
    }

    set currentPage(value: number)
    {
        this._currentPage = value;
    }

    get results()
    {
        return this.searchResult;
    }

    private _searchViewCollapsed: boolean = true;

    get searchViewCollapsed(): boolean
    {
        return this._searchViewCollapsed;
    }

    set searchViewCollapsed(value: boolean)
    {
        this._searchViewCollapsed = value;
    }

    ngOnInit()
    {
        this.currentPage = 0;
        this.pageSize = 10;
    }

    searchByCriteria(searchCriteria: any)
    {
        this.currentPage = 0;
        this.pageSize = 10;
        this.refreshSearch(searchCriteria);
    }

    register(searchService: ISearchableService)
    {
        this.searchableService = searchService;
    }

    updatePage(pageNumber: number)
    {
        this.currentPage = pageNumber;

        if (this.currentPage < 0)
        {
            this.currentPage = 0;
        }

        if (this.currentPage >= this.results.totalPages)
        {
            this.currentPage = this.results.totalPages - 1;
        }

        this.refreshSearch(this.searchableCriteria);
    }

    ngOnDestroy(): void
    {
        this.searchResult = undefined;
        this.searchableService = undefined;
        this.currentPage = 0;
        this.pageSize = 10;
    }

    refreshSearch(searchCriteria: any)
    {
        this.searchableService.search(
            this.currentPage,
            this.pageSize,
            this.field,
            this.direction,
            searchCriteria).subscribe(searchResult =>
        {
            this.searchResult = searchResult;
        });
    }
}